import React, { useState } from "react";
import { Form, Button, Row, Col, Spin } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import MyInput from "../utility/myInput/MyInput";
import MyCard from "../utility/myCard/MyCard";
import { useNavigate } from "react-router-dom";
import { AuthUser, FirebaseContextType } from "../dtype/All";
import { useFirebase } from "../../context/Firebase";
import { SUCCESS } from "../../utils/messages";

const { Item } = Form;

const SignIn: React.FC = () => {
  const firebase: FirebaseContextType | null = useFirebase();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const onFinish = async (values: any) => {
    setLoading(true);
    const payload: AuthUser = {
      email: values.email,
      password: values.password,
    };

    try {
      const result: any = await firebase?.siginEmailPassword(payload);

      if (result === SUCCESS) {
        if (!firebase?.isUserExistInCollection && firebase?.isLogin) {
          navigate("/mde-onboarding");
        }
        form.resetFields();
      }
    } catch (error) {
      console.error("Unexpected error during sign-in:", error);
    }

    setLoading(false);
  };

  const validateMessages = {
    required: "${label} is required!",
    types: {
      email: "${label} is not a valid email!",
    },
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f2f5",
      }}
    >
      <img src="/images/1-BR.png" alt="Logo" style={{ marginBottom: 20 }} />
      <MyCard title="Sign In" style={{ width: 400 }}>
        <Form
          form={form}
          name="sign_in"
          onFinish={onFinish}
          validateMessages={validateMessages}
          layout="vertical"
        >
          <Item
            name="email"
            label="Email"
            rules={[{ type: "email", required: true }]}
          >
            <MyInput prefix={<MailOutlined />} placeholder="Enter your email" />
          </Item>
          <Item name="password" label="Password" rules={[{ required: true }]}>
            <MyInput
              type="password"
              prefix={<LockOutlined />}
              placeholder="Enter your password"
            />
          </Item>
          <Item>
            <Button type="primary" htmlType="submit" block>
              Sign In
            </Button>
          </Item>
        </Form>
        <Row>
          <Col span={12}>
            <Button type="link" onClick={() => navigate("/signup")}>
              Register Here
            </Button>
          </Col>
          <Col span={12}>
            <Button type="link" onClick={() => navigate("/reset-passowrd")}>
              Reset Password
            </Button>
          </Col>
        </Row>
      </MyCard>
      <Spin spinning={loading} fullscreen />
    </div>
  );
};

export default SignIn;
